import { CriteriaAnswerTypeCode } from "./enums/CriteriaAnswerTypeCodeEnum"

export class CriteriasToEvaluateProduct {
  productId: number
  productName: string
  productImage: any
  criterias: Criteria[]
}

export class Criteria {
  id: number
  name: string
  order: number
  isAttachmentsRequired: boolean
  technicalCriteriaAnswerTypeCode: CriteriaAnswerTypeCode
  textAnswer: any
  numericAnswer: any
  answerValue: any
  starRateEnum: any
  selectedAnswerId: any
  attachmentUrls: any[]
  criteriaAnswers: any[]
}
